// global bbOutlookModes
/***
 * !!!!!! HEADS UP !!!!!!
 *
 * THIS FILE IS USED IN A CONSTRAINED ENVIRONMENT
 * SEE src/constrained/README.md FOR MORE INFORMATION
 *
 * Outlook for Windows runs the compose functions in a limited javascript environment,
 * please try to limit the items being imported here to the absolute minimum as it is
 * very hard to determine if things go wrong and how.
 *
 * If using some of the common abstractions, check their imports and extract to a
 * common function if necessary.
 */

// The functions in this file correspond to options provided in the window's
// location hash. These options are set by the manifest that is loaded and are
// written out in manifest.ts.

/** Determines if the application is configured to track only emails with directly inserted BombBomb videos. */
export function isConfiguredForAutoTracking(): boolean {
  const mode = getMode('auto-tracking') || isConfiguredForFidelity();
  return mode !== null && mode;
}

/** Determines if the application is configured to run Fidelity specific code. */
export function isConfiguredForFidelity(): boolean {
  const mode = getMode('fidelity-investments');
  return mode !== null && mode;
}

/** Determines if native sending is enabled. */
export function isNativeSend(): boolean {
  const mode = getMode('native-send');
  return mode !== null && mode;
}

/** Determines if tracking is on or off by default. */
export function trackByDefault(): boolean {
  const mode = getMode('track-by-default');
  // this one is different as the absence of the item will default to tracking
  // turned on allowing us to avoid us from needing to submit a new manifest
  // to the store to change the default from yes to no.
  return mode === null || mode;
}

/** Determines if transcript attachment should be enforced. */
export function transcriptEnforcement(): boolean {
  const mode = getMode('transcript-enforcement');
  return mode !== null && mode;
}

type OutlookMode =
  | 'auto-tracking'
  | 'fidelity-investments'
  | 'native-send'
  | 'track-by-default'
  | 'transcript-enforcement';

/**
 * Gets the current setting for the requested mode. Will return true if the
 * mode exists and is enabled, false if the mode exists and is disabled, and
 * null if the mode was not found in the list.
 */
function getMode(mode: OutlookMode): boolean | null {
  const modes = getModes();
  const entry = modes.find((m) => m.includes(mode));
  if (!entry) {
    return null;
  }

  return !entry.startsWith('no-');
}

declare const bbOutlookModes: string[] | undefined;

export function getModes(): string[] {
  if (typeof bbOutlookModes !== 'undefined') {
    return bbOutlookModes;
  }

  return window.location.hash.substring(1).split(',');
}
